import { AbstractDrawableValuedItem } from "./AbstractDrawableValuedItem";

export abstract class AbstractRectangleValuedItem extends AbstractDrawableValuedItem {
  constructor(typeKey: string, value: any) {
    super(typeKey, value);
  }
}
